"use client";

import { usePathname } from "next/navigation";
import NavigationBreadcrumbs, { type Breadcrumb } from "@/components/common/navigation-breadcrumbs";

const sectionLabels: Record<string, string> = {
  balance: "Balance Calii",
  membresia: "Membresía Calii+",
  perfil: "Perfil",
  promociones: "Promociones y beneficios",
  direcciones: "Direcciones de entrega",
};

export default function CuentaBreadcrumbs() {
  const pathname = usePathname();
  const segment = pathname.split("/")[2]; // e.g. "balance" from "/cuenta/balance"
  const sectionLabel = segment ? sectionLabels[segment] : undefined;

  const breadcrumbs: Breadcrumb[] = sectionLabel
    ? [
        { label: "Cuenta", href: "/cuenta" },
        { label: sectionLabel, href: null },
      ]
    : [{ label: "Cuenta", href: null }];

  return <NavigationBreadcrumbs breadcrumbs={breadcrumbs} />;
}
